import React from 'react'

/**
 * LoadingSpinner component
 * Reusable loading spinner with accessibility support
 */
function LoadingSpinner({ 
  size = 'md', 
  message = 'Loading...', 
  inline = false,
  className = '' 
}) {
  const sizeClass = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border-lg'
  }[size] || ''

  const Component = inline ? 'span' : 'div'

  return (
    <Component className={`text-center ${className}`}>
      <div 
        className={`spinner-border text-primary ${sizeClass}`} 
        role="status"
        aria-label={message}
      >
        <span className="visually-hidden">{message}</span>
      </div>
      {!inline && message && (
        <p className="mt-2 text-muted">{message}</p>
      )}
    </Component>
  )
}

export default LoadingSpinner
